import React, { FC } from 'react';
import { SectionTitle } from '../shared';
import styled from 'styled-components';

const Section = styled.section`
  margin-top: 4rem;
  padding: 1.5rem 0 3rem;

  @media (max-width: 768px) {
    margin-top: 2.5rem;
    padding: 1rem 0 2rem;
  }
`;

// ===============
// Perks panel
// ===============
const PerksPanel = styled.div`
  max-width: 960px;
  margin: 1rem auto 0;
  padding: 2rem;
  background: linear-gradient(62deg, #6b000d 0%, #990000 100%);
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(107, 0, 13, 0.25);
  color: #fff;

  .panel-title {
    font-size: clamp(1.25rem, 2.2vw, 1.6rem);
    font-weight: 800;
    letter-spacing: 0.01em;
    line-height: 1.3;
    margin: 0 0 1.5rem;
    text-align: center;
  }

  .perks {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem 1.25rem;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .perks li {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 10px;
    padding: 0.7rem 1rem;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.4;
    transition: background 0.2s ease, transform 0.2s ease;
  }

  .perks li:hover {
    background: rgba(255, 255, 255, 0.16);
    transform: translateY(-2px);
  }

  .perks li::before {
    content: '✓';
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    background: #fff;
    color: #990000;
    font-weight: 800;
    font-size: 0.85rem;
  }

  @media (max-width: 768px) {
    padding: 1.5rem 1.25rem;
    margin-left: 1rem;
    margin-right: 1rem;
    .perks { grid-template-columns: 1fr; }
  }
`;

const Affiliates: FC = () => {
  return (
    <Section>
      <SectionTitle color="black">
        Enjoy Perks from Our Sponsors
      </SectionTitle>
      <PerksPanel>
        <p className="panel-title">Our sponsors power your podcast journey</p>
        <ul className="perks">
          <li>Job opportunities</li>
          <li>Access to Stony Brook recording studios</li>
          <li>One-on-one technical instruction</li>
          <li>Sponsor-provided tools</li>
          <li>Invitations to industry events</li>
          <li>Publishing opportunities</li>
          <li>Career support via our active alumni network</li>
          <li>.edu discounts across key tools and platforms</li>
        </ul>
      </PerksPanel>
    </Section>
  );
};

export default Affiliates;
